"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/style/Fill
 */

/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|null} [color=null] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */

/**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */
var Fill =
/** @class */
function () {
  /**
   * @param {Options} [opt_options] Options.
   */
  function Fill(opt_options) {
    var options = opt_options || {};
    /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|null}
     */

    this.color_ = options.color !== undefined ? options.color : null;
  }
  /**
   * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */


  Fill.prototype.clone = function () {
    var color = this.getColor();
    return new Fill({
      color: Array.isArray(color) ? color.slice() : color || undefined
    });
  };
  /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|null} Color.
   * @api
   */


  Fill.prototype.getColor = function () {
    return this.color_;
  };
  /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|null} color Color.
   * @api
   */


  Fill.prototype.setColor = function (color) {
    this.color_ = color;
  };

  return Fill;
}();

var _default = Fill;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7Ozs7QUFPQTs7Ozs7QUFLQTtBQUFBO0FBQUE7RUFDRTs7O0VBR0EsY0FBWUEsV0FBWixFQUF1QjtJQUNyQixJQUFNQyxPQUFPLEdBQUdELFdBQVcsSUFBSSxFQUEvQjtJQUVBOzs7OztJQUlBLEtBQUtFLE1BQUwsR0FBY0QsT0FBTyxDQUFDRSxLQUFSLEtBQWtCQyxTQUFsQixHQUE4QkgsT0FBTyxDQUFDRSxLQUF0QyxHQUE4QyxJQUE1RDtFQUNEO0VBRUQ7Ozs7Ozs7RUFLQUU7SUFDRSxJQUFNRixLQUFLLEdBQUcsS0FBS0csUUFBTCxFQUFkO0lBQ0EsT0FBTyxJQUFJRCxJQUFKLENBQVM7TUFDZEYsS0FBSyxFQUFFSSxLQUFLLENBQUNDLE9BQU4sQ0FBY0wsS0FBZCxJQUF1QkEsS0FBSyxDQUFDTSxLQUFOLEVBQXZCLEdBQXVDTixLQUFLLElBQUlDO0lBRHpDLENBQVQsQ0FBUDtFQUdELENBTEQ7RUFPQTs7Ozs7OztFQUtBQztJQUNFLE9BQU8sS0FBS0gsTUFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7RUFNQUcsb0NBQVNGLEtBQVQsRUFBYztJQUNaLEtBQUtELE1BQUwsR0FBY0MsS0FBZDtFQUNELENBRkQ7O0VBR0Y7QUFBQyxDQTVDRDs7ZUE4Q2VFLEkiLCJuYW1lcyI6WyJvcHRfb3B0aW9ucyIsIm9wdGlvbnMiLCJjb2xvcl8iLCJjb2xvciIsInVuZGVmaW5lZCIsIkZpbGwiLCJnZXRDb2xvciIsIkFycmF5IiwiaXNBcnJheSIsInNsaWNlIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdHlsZS9GaWxsLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19